  import { Injectable, Inject } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ErrorHandlerService, AuthenticationService, AuthorizationService, ConnectApiClientService } from '@aveva/connect-web-core';
import { AccountWithIcon } from '../training/account-with-icon';
import { environment } from 'src/environments/environment';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import * as globals from '../training/globals';
import { LoggingService } from './logging.service';

@Injectable()
export class AccountResolverService implements Resolve<AccountWithIcon> {
  constructor(
    private errorHandler: ErrorHandlerService,
    private authenticationService: AuthenticationService,
    private authorizationService: AuthorizationService,
    private connectApiClient: ConnectApiClientService,
    private http: HttpClient,
    private logger: LoggingService
  ) { }

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const userData = await this.authenticationService.getUser();
      const result = await this.connectApiClient.accountManagement.getAccount(userData.account);
      const accountWithIcon: AccountWithIcon = result;
      try {
        this.setPolicies();
        
        const icon = await firstValueFrom(this.http.get(`${environment.apis.am}/accounts/${result.id}/icon`, { responseType: 'text' }));
        if (icon) {
          accountWithIcon.icon = `data:image/png;base64,${icon}`;
        }
      } catch (error) { this.logger.logException(error); }

      return result;
    } catch (error) {
      this.logger.logException(error);
      await this.authenticationService.navigateToSignIn();
      return;
    }
  }

  private async setPolicies() {
    const isAdministrator = await this.authorizationService.hasPolicy(`${globals.TC}:${globals.trainingadmin}`, globals.tcrequests);
    if(isAdministrator) {
      localStorage.setItem(globals.POLICIES, `${globals.TC}:${globals.trainingadmin}`);
      return;
    }

    const isContributor = await this.authorizationService.hasPolicy(`${globals.TC}:${globals.trainer}`, globals.tcrequests);
    if (isContributor) {
      localStorage.setItem(globals.POLICIES, `${globals.TC}:${globals.trainer}`);
      return;
    }

    const isViewer = await this.authorizationService.hasPolicy(`${globals.TC}:${globals.viewer}`, globals.tcrequests);
    if (isViewer) {
      localStorage.setItem(globals.POLICIES, `${globals.TC}:${globals.viewer}`);
      return;
    }
  }
}
